import type { FlowProcessMessage } from "@repo/shared/types";
import { useT } from "@/lib/i18n/use-t";
import { FeedbackCard } from "./feedback-card";
import { T } from "./feedback-card-list.i18n";

type FeedbackCardListProps = {
  messages: FlowProcessMessage[];
  /** For the cards' relative times only; the words follow `useT`. */
  language: string;
  /** Locked flow that can actually be returned to editing — see FeedbackCard. */
  showReopenInstruction: boolean;
  onDismiss: (messageId: string) => void;
};

/**
 * The stack of undismissed feedback, between the header and the tabs.
 *
 * Newest first, and every outstanding message is here at once — external
 * review and compliance can appear together, and feedback from an earlier
 * round sits alongside the current one until somebody closes it.
 */
export function FeedbackCardList({
  messages,
  language,
  showReopenInstruction,
  onDismiss,
}: FeedbackCardListProps) {
  const t = useT(T);
  if (messages.length === 0) return null;

  return (
    <div className="space-y-3">
      {messages.map((message) => (
        <FeedbackCard
          key={message.id}
          message={message}
          language={language}
          showReopenInstruction={showReopenInstruction}
          onDismiss={onDismiss}
        />
      ))}
      <p className="text-sm text-muted-foreground">{t.dismissNote}</p>
    </div>
  );
}
